import register from 'preact-custom-element'

import { WrappedQuickSearch } from 'libs/searchspring/components/quick-search/QuickSearch'
import { WrappedSearchGrid } from 'libs/searchspring/components/SearchGrid'
import { WrappedCollectionGrid } from 'libs/searchspring/components/collection/CollectionGrid'

import { CarouselCollection, CarouselRecommend, GridRecommend, observedAttributes } from 'libs/searchspring/components/recommendations/Recommendations'

import { CarouselTabbed } from 'libs/searchspring/components/recommendations/CarouselTabbed'
import { GridTabbed } from 'libs/searchspring/components/recommendations/GridTabbed'

// Handle Registering Custom Elements

register(WrappedQuickSearch, 'x-ss-quick-search')
register(WrappedSearchGrid, 'x-ss-search-grid')
register(WrappedCollectionGrid, 'x-ss-collection-grid', ['per-page'], { shadow: false })

register(CarouselRecommend, 'x-ss-carousel-recommend', observedAttributes, { shadow: false })
register(CarouselTabbed, 'x-ss-carousel-tabbed', observedAttributes, { shadow: false })
register(CarouselCollection, 'x-ss-carousel-collection', observedAttributes, { shadow: false })
register(GridRecommend, 'x-ss-grid-recommend', observedAttributes, { shadow: false })
register(GridTabbed, 'x-ss-grid-tabbed', observedAttributes, { shadow: false })
